import { Component, Input,OnInit,HostListener,ViewChild,ElementRef } from '@angular/core';
import {NgbModal, ModalDismissReasons,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { contentService } from '../../service/content.service';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { FileSelectDirective,FileUploader,FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import {Globals} from '../.././globals';
//import { Http, ResponseContentType } from '@angular/http';
import { commonService } from '../../service/common.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { saveAs } from 'file-saver/FileSaver';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient, HttpRequest, HttpEvent, HttpEventType } from '@angular/common/http';
declare var $: any;

@Component({
  selector: 'app-freedownload',
  templateUrl: './freedownload.component.html',
  styleUrls: ['./freedownload.component.css'],
  providers:[contentService]
})
export class FreedownloadComponent implements OnInit {
  //formoptions:any={};
  
  modalReference:NgbModalRef;
  topicbox:any;
  doc:any;
  tagposttopic:any;
  msg:any;
  isError=false;
  isSuccess=false;
  formvailidation=false;
  topic:any;
  docId:any;
  contentTitle:any;
  contentlist=[];
  topiclist:any;
  isPostLoad=true;
  isRemaningForum=true;
  noMoreResults=false;
  obj={};
  searchtxt:any;
  userData:any;
  isclickbutton=false;
  pathsocialsh:any;
  fileUrl:any;
  percentDone=0;
  activeCurrentDwnld = [];
  progress:any=0;

  Freedownload={'title':'GATE, ESE and PSU Study Materials and Notes free download','desciprtion':'Free PDF download of GATE and ESE Study Material, Notes and Book for EE, ME, EC, CE, CS/IT and General Studies.','keywords':'GATE Study Material, topper notes, books for gate, ESE preparation, Book PDF free download, EE, ME, EC, CE, CS/IT, General Studies'};
  
  
  @ViewChild('contentbox', {read: ElementRef}) contentbox: ElementRef;
  //@ViewChild('fileformaticon') public fileformaticon:ElementRef;
 


  readonly rootUrl = this.global.siteUrl;
  readonly profileUrl  =  this.global.profileUrl;
  url =this.rootUrl+'file/upload?folder='+this.global.docAttachmentFolder;
  path=this.global.docAttachmentUrl;
  @Input() fileExt: string = "";
  errors: Array<string> =[];
  fileExtExists=false;
  uploader:FileUploader=new FileUploader({url:this.url,authToken:localStorage.getItem('_to'),maxFileSize: 20000000 ,allowedMimeType: ['image/png','image/jpeg','image/jpg','application/pdf','video/mp4','application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/vnd.ms-powerpoint','application/vnd.openxmlformats-officedocument.presentationml.presentation','application/vnd.openxmlformats-officedocument.wordprocessingml.document','application/msword']});
  attactmentlist:any=[];
  userid:any;
  
  @Input() public options;
  formoption:any={createpost:true};
  readonly filepathUrl  =  this.global.docAttachmentUrl;
  constructor(private sanitizer: DomSanitizer,public el: ElementRef,private http:HttpClient,private modalService: NgbModal,private _content:contentService,private router:Router,private global:Globals,private _common:commonService,private permissionsService: NgxPermissionsService) {


    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
    this.uploader.clearQueue = ()=>this.clearQueue();
    this.uploader.onWhenAddingFileFailed = (fileItem) => {
      this.msg="File size must 20mb or below.";
      this.isError = true;
      this.isSuccess = false;
    }
    
    this._common.profile.subscribe((data:any)=>{
      if(typeof data=='object' &&  data!=null){
        this.userData = data;
         this.userid = data.id;
         this.contentlist=[];
         this.isPostLoad=true;
         this.getdownloadContent();
      }else{
        this.userData={};
        
      } 
   })
   
   this.pathsocialsh=this.global.websiteUrl+'freedownload/';
      
  }

   @HostListener('window:scroll', ['$event'])
   checkScroll() {
      var scrollPosition = $(window).scrollTop() + $(window).height();
      var pageheight =  $(document).height()-$('#footer-section').outerHeight();
      //var pageheight =  $(document).height()-100;
      if(scrollPosition >= pageheight && this.isRemaningForum==true && this.contentlist.length>0) {
        this.isPostLoad=true;
        this.getdownloadContent();
      }
   }


  ngOnInit() {
    window.scrollTo(0, 0);
    
    if(!this.options){
      this.formoption={}
     }else{
      this.formoption=this.options;
     }
    
    this.obj['limit']=20;
    this.getposttopic();
   
  }

  onFileChanged($event){
    this.uploader.uploadAll();
    this.progress=1;
  }
  

  uploadComment(commnetobj,content){   
    this.open(content);
  }

     
  open(content) {
    this.isError=false;
    this.isSuccess=false;
    this.formvailidation=false;
    this.modalReference =  this.modalService.open(content,{ size: 'lg' }); 
  }


  getdownloadContent(){
    this.obj['offset']= this.contentlist.length?this.contentlist.length:0;
    this.obj['search'] = this.searchtxt?this.searchtxt:'';
    this.obj['userid']=this.userData?this.userData.id:'';

    if(this.formoption.bookmarkType=='freedownload'){
      this.obj['isbookmark']=1;   
    }else{
      this.obj['isbookmark']=0;  
    }

    this._content.getdownloadContent(this.obj).subscribe((data : any)=>{     
      if(data.error==0){ 
        if(data.results.rows.length > 0){    
          this.isPostLoad=false;
          Array.prototype.push.apply(this.contentlist,data.results.rows);
        }else{
          this.isRemaningForum=false;
          this.isPostLoad=false;
          this.noMoreResults = true;
        }
    }else{
        if(data.message=="Failed to authenticate token."){
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        }else{
         this.msg = data.message;
         this.isError = true;
        }
      }
    },
    (error : HttpErrorResponse)=>{
    this.isError = true;
    this.msg="internal server error!";
    }); 


  }

  getposttopic(){
    var category='Material';
    this._content.getposttopic(category).subscribe((data : any)=>{     
      if(data.error==0){     
        this.getdownloadContent();
       var objArray = {};
       var mainArray = [];
       var newArray  = {}
       
       for(var row of data.results){
          objArray['display']= row.title;
          objArray['value']= row.id;
          newArray[row.id]=row.title;
            mainArray.push(objArray);
            objArray = {};
        }
       this.topicbox = mainArray;
       this.topiclist = newArray;
     
       
       //this.topic=this.getpermissionArray(this.tagposttopic,this.topicbox);

      // console.log(this.topic);
      
    }else{
        if(data.message=="Failed to authenticate token."){
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        }else{
         this.msg = data.message;
         this.isError = true;
        }
      }
    },
    (error : HttpErrorResponse)=>{
    this.isError = true;
    this.msg="internal server error!";
    });  
    

  }

  getpermissionArray(selectedtag,tagarray){ 
    var selectedArray = [];
    if(tagarray instanceof Array){
     for(var tag of  tagarray){
       var personRegExp = new RegExp(tag.value);
       if(personRegExp.test(selectedtag)) {
            selectedArray.push(tag);
       }
     }
   }
     return selectedArray;
}


/****file uploder responce***/
onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
  let data = JSON.parse(response); //success server response

    if(data.error==0){
      this.progress=0;
      this.attactmentlist.push(data.result.id);
    }
 
   
}

onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    let error = JSON.parse(response); //error server response
    //console.log(error);
}  


ngAfterViewInit() {
  this.uploader.onAfterAddingFile = (item => {
     item.withCredentials = false;
  });
 }

 clearQueue() {
  this.uploader.queue = [];
  this.attactmentlist=[];
  
  
 }
/****file uploder responce***/

saveContent(contentForm){
  this.isclickbutton=true;
  if(contentForm.status=="INVALID" ||  this.attactmentlist.length==0){
    this.formvailidation=true;
    this.isclickbutton=false;
   }else{
    this.formvailidation=false;
    contentForm.value['attachment']  =  this.attactmentlist;
    this._content.adddocDownload(contentForm.value).subscribe((data : any)=>{
    if(data.error==0){ 
      this.isclickbutton=false;
      this.docId  = data.docId;
      this.uploader.queue = [];
      this.attactmentlist=[];
      this.msg="This Materials is pending approval, It will start to appear in the Materials forum once it gets approved by the Moderator.";
      this.isError = false;
      this.isSuccess = true;
      this.contentTitle="";
      this.topic="";
      this.contentlist=[];
      this.getdownloadContent();
     // this.modalReference.close();
  //    this.router.navigateByUrl('/admin/content/addpdf?did='+this.docId);
    }else{
      if(data.message=="Failed to authenticate token."){
        this.router.navigate(['/admin']);
      }else{
      this.msg = data.message;
      this.isError = true;
      this.isSuccess = false;
      this.isclickbutton=false;

      }
    }
},
    (error : HttpErrorResponse)=>{
      this.isError = true;
      this.msg="internal server error!";
    });

} 
  
  }

 topicfunc(data){
  return  data.split(',');
  }

  datediff(date){
    return this._common.datediff(date);

   }
   

   public downloadFile(filename) {
     var downloadurl=this.path+filename;
      if(Object.keys(this.userData).length == 0){ 
        this.needLogin();
        return false;
      } 
      
    this.percentDone = 0;
    this.activeCurrentDwnld[filename] = true;
    const req = new HttpRequest('GET', downloadurl, {
      reportProgress: true,
      responseType: 'blob'
    });
  
    this.http.request(req).subscribe((event: HttpEvent<any>) => {
      switch (event.type) {
        case HttpEventType.Sent:
          console.log('Request sent!');
          break;
        case HttpEventType.ResponseHeader:
          console.log('Response header received!');
          break;
        case HttpEventType.DownloadProgress:
          this.percentDone = Math.round(100 * event.loaded / event.total);
          console.log( this.percentDone);
          break;
        case HttpEventType.Response:
          console.log('Done!', event);
          let file = event.body;
          console.log(file.size + " bytes file downloaded. File type: ", file.type);                
          // create and download link
          var url = window.URL.createObjectURL(file);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove(); // remove the element */
  
      }
  
    }, error => {
      if(error.status="404"){
             alert('Something went wrong. Please try to latter.');
             this.percentDone = 0;
             this.activeCurrentDwnld[filename] = false;
      }
    }, () => {
      this.percentDone = 0;
      this.activeCurrentDwnld[filename] = false;
     });
}

delcontent(docId){
if(confirm('are you sure do want to delete?')){
  this.obj['userid']=this.userData?this.userData.id:'';
  this.obj['docId']=docId;
 
  this._content.deldownloadContent(docId).subscribe((data : any)=>{     
    if(data.error==0){ 
      this.contentlist.forEach( (data, index) => {
        if(data.id == docId) this.contentlist.splice(index,1);
      });
   
  }else{
      if(data.message=="Failed to authenticate token."){
        sessionStorage.clear();
        localStorage.clear();
        this.router.navigate(['/']);
      }else{
       this.msg = data.message;
       this.isError = true;
      }
    }
  },
  (error : HttpErrorResponse)=>{
  this.isError = true;
  this.msg="internal server error!";
  }); 
}

}

filterform(searchtxt){
  var txt = searchtxt.value.search.trim();
  if(txt!=""){
  this.router.navigateByUrl('/freedownload?search='+txt);
  }else{
    this.router.navigateByUrl('/freedownload');
  }
  this.searchtxt=txt;
  this.contentlist=[];
  this.noMoreResults = false;
  this.getdownloadContent(); 
}


autoload(val){
 
 // console.log(this.topicbox);
  //var filtered = this.topicbox.filter(a=>a.display.toString().toLowerCase()===event.toString().toLowerCase());

  
if(val!=""){
  var filtered = this.topicbox.filter((item) => {
    return (item.display.charAt(0).toLowerCase().indexOf(val.toLowerCase()) >= -1 ||
    item.display.toLowerCase().indexOf(val.toLowerCase()) >= -1 );
})
//console.log(filtered);
}
}




gettopic(topicId){
    var encodeURI =   encodeURIComponent(btoa(topicId));
    //return false;
     this.router.navigateByUrl('/topic/'+encodeURI);
}


checkFileextension(fileName){

  return this._common.checkFileextension(fileName);
}

needLogin(){
  this._common.setLoginBox(true);        
}

/*=============================== Like =================*/
postLike(feed,react){ 
 
  if(Object.keys(this.userData).length == 0){ 
    this.needLogin();
    return false;
  }      
  var obj={};
  obj['userId']=this.userData.id;
  obj['postId']=feed.id;
  obj['react']=react;    

      this._content.savePostLike(obj).subscribe((data:any)=>{
        if(data.error==0){
          this.postLikefunc(feed,react,data.message);             
       }               
      },(error : HttpErrorResponse)=>{              
          this.msg="internal server error!";
      })  
  

}

postLikefunc(postObj,react,action){

  if(!postObj.groupLikeCount){
    postObj.groupLikeCount=0;
  }
  if(!postObj.groupunLikeCount){
    postObj.groupunLikeCount=0;
  }

   // react=0 unlike
  if(react==0 && action=="added"){ 
          postObj.mylike=0;
          postObj.groupunLikeCount +=1;
          postObj.mylikeAction='Unlike';
      } else if(react==0 && action=="updated"){
        postObj.mylike=0;
        postObj.groupLikeCount -=1;
        postObj.groupunLikeCount +=1;
        postObj.mylikeAction='Unlike';
      }else if(react==1 && action=="added"){
          postObj.mylike=1;
          postObj.groupLikeCount +=1;
          postObj.mylikeAction='Like';
      }else if(react==1 && action=="updated"){
        postObj.mylike=1;
        postObj.groupLikeCount +=1;
        postObj.groupunLikeCount -=1;
        postObj.mylikeAction='Like';
      } else if(react==0 && (action=="removed")){
          postObj.mylike=0;
          postObj.groupunLikeCount -=1;
          postObj.mylikeAction='';
      }else if(react==1 && (action=="removed")){
          postObj.mylike=0;
          postObj.groupLikeCount -=1;
          postObj.mylikeAction='';
      }

     // console.log(postObj);

}

bookmark(postObj,type){
  if(Object.keys(this.userData).length == 0){ 
    this.needLogin();
    return false;
  }   
  var obj={};
  obj['postId']=postObj.id;
  obj['userId']=this.userData.id;
  obj['type']=type;
  this._content.bookmark(obj).subscribe((data:any)=>{
    if(data.error==0){
      if(type=='bookmark'){
        postObj.mybookmark=1;
      }else{
        postObj.mybookmark=0;
      }
      postObj.showOption=false;
  
    }
  
  },(error:HttpErrorResponse)=>{
    this.msg="internal server error!";
  })
  
  }

  sharesocial(sharesocial){
    sharesocial.action=true;
    this._common.setSocialSharingBox(sharesocial);
  }
}





// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/freedownload/freedownload.component.ts